import HTTP from '../../../../api/AxiosConfig';

export const getTodayMenu = () =>
    HTTP.get('/menu-today').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const getDeclarationStatus = () =>
    HTTP.get('/menu-today/status').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const getDeclaredPeople = () =>
    HTTP.get('/menu-today/declared').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const declarePeople = (people) => HTTP.post('/menu-today', people);

export const fetchExcel = () =>
    HTTP.get('/menu-today/excel', {
        method: 'GET',
        responseType: 'blob'
    }).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const fetchNextDayExcel = () =>
    HTTP.get('/menu-today/next-day-excel', {
        method: 'GET',
        responseType: 'blob'
    }).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );